import QuickPanel from 'app/fuse-layouts/shared-components/quickPanel/QuickPanel';
import React from 'react';

const RightSideLayoutAdmin = () => {
	return (
		<>
			<QuickPanel />
		</>
	);
};

export default React.memo(RightSideLayoutAdmin);
